import { GET_F2W_SETTINGS_SUCCESS } from 'Constants/SettingConstants';

const defaultState = {};

export default function settingReducer(state = defaultState, action) {
  if (action.type === GET_F2W_SETTINGS_SUCCESS) {
    return {
      ...state,
      f2wSettings: action.data.settings,
    };
  }
  return state;
}
